import React, { useEffect, useState, useContext, useRef } from "react";
import Select from "react-select";
import { BuilderContext } from "./../BuilderContext";

const BuilderFilter = ({
  filterDetail,
  insideCondition,
  setFilterDefinition,
  setfilterToCondition,
  updateConditionfunction,
  position,
  updateFilterdetails,
  remove_filter_inside_condition,
  toUpdate,
}) => {
  const {
    categoriesList,
    attributesList,
    masterdata,
    filter_template,
    globalFilter,
    setSelectedAttr,
  } = useContext(BuilderContext);
  const [filterDetailData, setfilterDetailData] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedAttributes, setselectedAttributes] = useState([]);
  const [selectedValues, setselectedValues] = useState([]);
  const [selectedMinValues, setselectedMinValues] = useState([]);
  const [selectedMaxValues, setselectedMaxValues] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState([]);
  const [dropDownSelectedCategories, setdropDownSelectedCategories] = useState(
    []
  );
  const [dropDownSelectedAttributes, setdropDownSelectedAttributes] = useState(
    []
  );
  const [dropDownSelectedValues, setdropDownSelectedValues] = useState([]);
  const [showError1, setShowError1] = useState(false);
  const [showError2, setShowError2] = useState(false);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const prevSelectedCategories = usePrevious(selectedCategories);
  const prevSelectedAttributes = usePrevious(selectedAttributes);

  useEffect(() => {
    if (
      filterDetail &&
      JSON.stringify(filterDetail) !== JSON.stringify(filterDetailData)
    ) {
      setfilterDetailData(filterDetail);
    }
  }, [filterDetail]);

  const update_cat_attr_list = (categorieslist = []) => {
    if (masterdata) {
      let cat_list = [];
      let attr_list = [];
      let attr_for_cat = [];
      for (let cat in masterdata) {
        attr_for_cat = [];
        cat_list.push({
          label: masterdata[cat]["name"],
          value: masterdata[cat]["id"],
        });
        if (
          categorieslist.length === 0 ||
          categorieslist.includes(masterdata[cat]["id"])
        ) {
          const cat_attr = masterdata[cat]["attributes"];
          for (let attr in cat_attr) {
            if (globalFilter?.length > 0) {
              if (globalFilter.includes(cat_attr[attr]["id"])) {
                attr_for_cat.push({
                  label: cat_attr[attr]["name"],
                  value: cat_attr[attr]["id"],
                });
              }
            } else {
              attr_for_cat.push({
                label: cat_attr[attr]["name"],
                value: cat_attr[attr]["id"],
              });
            }
          }

          attr_list.push({
            label: masterdata[cat]["name"],
            options: attr_for_cat,
          });
        }
      }
      setdropDownSelectedCategories(cat_list);
      setdropDownSelectedAttributes(attr_list);
    }
  };
  useEffect(() => {
    const categoriesList = [];
    for (let selcat of selectedCategories) {
      categoriesList.push(selcat["value"]);
    }
    update_cat_attr_list(categoriesList);
  }, [globalFilter]);

  useEffect(() => {
    if (filterDetailData) {
      setShowError1(false);
      setShowError2(false);
      let categorieslist = [];
      for (let arr in selectedCategories) {
        categorieslist.push(selectedCategories[arr]["value"]);
      }
      update_cat_attr_list(categorieslist);
      if (selectedCategories.length === 0 && selectedAttributes.length === 0) {
        setShowError1(true);
      }
      if (filterDetailData?.operator === "RANGE") {
        if (
          selectedCategories.length === 0 &&
          selectedAttributes.length > 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError2(true);
        }
      } else {
        if (
          selectedCategories.length === 0 &&
          selectedAttributes.length > 0 &&
          selectedValues.length === 0
        ) {
          setShowError1(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategories]);

  function format_attribute_value(attributeslist) {
    let value_list = [];
    let attr_val = [];
    for (let attr in attributeslist) {
      if (attributesList[attributeslist[attr]]) {
        let attr_value = attributesList[attributeslist[attr]].values;
        attr_val = [];
        for (let val in attr_value) {
          attr_val.push({
            key: val,
            value: attr_value[val],
            label: attr_value[val],
          });
        }
        value_list.push({
          key: attributesList[attributeslist[attr]]["name"],
          label: attributesList[attributeslist[attr]]["name"],
          options: attr_val,
        });
      }
    }
    setdropDownSelectedValues(value_list);
  }
  useEffect(() => {
    if (filterDetailData) {
      setShowError1(false);
      setShowError2(false);
      let attributeslist = [];
      if (selectedAttributes.length === 0) {
        setselectedValues([]);
      }
      for (let arr in selectedAttributes) {
        attributeslist.push(selectedAttributes[arr]["value"]);
      }
      format_attribute_value(attributeslist);
      if (selectedCategories.length === 0 && selectedAttributes.length === 0) {
        setShowError1(true);
      }
      if (filterDetailData?.operator === "RANGE") {
        if (
          selectedAttributes.length > 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError2(true);
        }
      } else {
        if (selectedAttributes.length > 0 && selectedValues.length === 0) {
          setShowError1(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAttributes]);

  useEffect(() => {
    if (filterDetailData) {
      setShowError1(false);
      setShowError2(false);
      if (filterDetailData?.operator === "RANGE") {
        if (
          selectedAttributes.length > 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError2(true);
        }
        if (
          selectedCategories.length === 0 &&
          selectedAttributes.length === 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError1(true);
        }
      } else {
        if (selectedAttributes.length > 0 && selectedValues.length === 0) {
          setShowError1(true);
        }
        if (
          selectedCategories.length === 0 &&
          selectedAttributes.length === 0 &&
          selectedValues.length === 0
        ) {
          setShowError1(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValues]);

  useEffect(() => {
    if (filterDetailData) {
      if (selectedOperator && selectedOperator.length > 0) {
        setShowError1(false);
        setShowError2(false);
        if (selectedOperator[0]["value"] === "RANGE") {
          if (
            selectedAttributes.length > 0 &&
            (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
          ) {
            setShowError2(true);
          }
          if (
            selectedCategories.length === 0 &&
            selectedAttributes.length === 0 &&
            (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
          ) {
            setShowError2(true);
          }
        } else {
          if (selectedAttributes.length > 0 && selectedValues.length === 0) {
            setShowError1(true);
          }
          if (
            selectedCategories.length === 0 &&
            selectedAttributes.length === 0 &&
            selectedValues.length === 0
          ) {
            setShowError1(true);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperator]);

  useEffect(() => {
    if (filterDetailData) {
      setShowError2(false);
      if (filterDetailData?.operator === "RANGE") {
        if (
          selectedAttributes.length > 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError2(true);
        }
        if (
          selectedCategories.length === 0 &&
          selectedAttributes.length === 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError2(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMaxValues]);

  useEffect(() => {
    if (filterDetailData) {
      setShowError2(false);
      if (filterDetailData.operator === "RANGE") {
        if (
          selectedAttributes.length > 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError2(true);
        }
        if (
          selectedCategories.length === 0 &&
          selectedAttributes.length === 0 &&
          (selectedMaxValues.length === 0 || selectedMinValues.length === 0)
        ) {
          setShowError2(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMinValues]);

  useEffect(() => {
    if (filterDetailData && JSON.stringify(categoriesList) !== "{}") {
      const { categories, attributes, operator, values, min, max } =
        filterDetailData;
      let formated_category = [];
      for (let cat in categories) {
        if (categoriesList[categories[cat]]) {
          formated_category.push({
            value: categories[cat],
            label: categoriesList[categories[cat]],
          });
        }
      }
      let formated_attributes = [];
      for (let attr in attributes) {
        if (attributesList[attributes[attr]]) {
          formated_attributes.push({
            value: attributes[attr],
            label: attributesList[attributes[attr]]["name"],
          });
        }
      }
      let formated_value = [];
      for (let val in values) {
        formated_value.push({ value: values[val], label: values[val] });
      }
      const operator_label = {
        EQ: "==",
        GT: ">",
        LT: "<",
        GTE: ">=",
        LTE: "<=",
        NOT_EQ: "!=",
        RANGE: "RANGE",
      };
      const formated_operator = {
        value: operator,
        label: operator_label[operator],
      };
      setSelectedOperator([formated_operator]);
      setSelectedCategories(formated_category);
      setselectedAttributes(formated_attributes);
      update_cat_attr_list(categories);
      if (operator === "RANGE") {
        const formatted_min = min ? [{ label: min, value: min }] : [];
        const formatted_max = max ? [{ label: max, value: max }] : [];
        setselectedMaxValues(formatted_max);
        setselectedMinValues(formatted_min);
        setselectedValues([]);
      } else {
        setselectedValues(formated_value);
        setselectedMaxValues([]);
        setselectedMinValues([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDetailData, categoriesList, attributesList]);

  const setUpdatedFilterDetailFunction = (data) => {
    if (data && data !== "null") {
      if (insideCondition) {
        updateFilterdetails(
          {
            function: "FILTER",
            filter: data,
          },
          position
        );
      } else {
        setFilterDefinition({
          function: "FILTER",
          filter: data,
        });
      }
    }
  };

  const updateCategorySelected = (data) => {
    setSelectedCategories(data);
    let categorieslist = [];
    for (let arr in data) {
      categorieslist.push(data[arr]["value"]);
    }
    let updated_filter_detail = {
      ...filterDetailData,
      categories: categorieslist,
    };
    if (
      prevSelectedCategories &&
      prevSelectedCategories.length === 0 &&
      data.length === 1
    ) {
      updated_filter_detail["attributes"] = [];
      updated_filter_detail["values"] = [];
    }
    setfilterDetailData(updated_filter_detail);
    setUpdatedFilterDetailFunction(updated_filter_detail);
  };

  const updateAttributeSelected = (data) => {
    setselectedAttributes(data);
    let attributeslist = [];
    if (selectedAttributes.length === 0) {
      setselectedValues([]);
    }
    if (Array.isArray(data)) {
      for (let arr in data) {
        attributeslist.push(data[arr]["value"]);
      }
    } else {
      attributeslist.push(data.value);
    }
    let updated_filter_detail = {
      ...filterDetailData,
      attributes: attributeslist,
    };
    if (
      prevSelectedAttributes &&
      prevSelectedAttributes.length === 0 &&
      data.length === 1
    ) {
      updated_filter_detail["values"] = [];
    }
    setfilterDetailData(updated_filter_detail);
    setUpdatedFilterDetailFunction(updated_filter_detail);
  };

  const updatedValueSelected = (data) => {
    setselectedValues([data]);
    let valueslist = [];
    if (
      filterDetailData.operator === "EQ" ||
      filterDetailData.operator === "NOT_EQ"
    ) {
      for (let arr in data) {
        valueslist.push(data[arr]["value"]);
      }
    } else {
      valueslist = [data.value];
    }
    const updatedFilterDetail = { ...filterDetailData, values: valueslist };
    setfilterDetailData(updatedFilterDetail);
    setUpdatedFilterDetailFunction(updatedFilterDetail);
  };

  const updatedMinValueSelected = (data) => {
    setselectedMinValues([data]);
    const updatedFilterDetail = { ...filterDetailData, min: data["value"] };
    setfilterDetailData(updatedFilterDetail);
    setUpdatedFilterDetailFunction(updatedFilterDetail);
  };

  const updatedMaxValueSelected = (data) => {
    setselectedMaxValues([data]);
    const updatedFilterDetail = { ...filterDetailData, max: data["value"] };
    setfilterDetailData(updatedFilterDetail);
    setUpdatedFilterDetailFunction(updatedFilterDetail);
  };

  useEffect(() => {
    if (dropDownSelectedCategories.length === 0) {
      setShowError1(true);
    }
    // if (dropDownSelectedAttributes.length === 0) {
    //   setShowError2(true);
    // }
  }, [dropDownSelectedCategories, dropDownSelectedAttributes]);

  const updatedOperatorSelected = (data) => {
    const operator_label = {
      EQ: "==",
      GT: ">",
      LT: "<",
      GTE: ">=",
      LTE: "<=",
      NOT_EQ: "!=",
      RANGE: "RANGE",
    };
    setSelectedOperator([
      { label: operator_label[data["value"]], value: data["value"] },
    ]);
    if (data["value"] !== "EQ" || data["value"] !== "NOT_EQ") {
      setselectedValues([]);
    }
    let updatedFilterDetail;
    const { industries, categories, attributes, values, min, max } =
      filterDetailData;
    if (data) {
      if (data["value"] === "RANGE") {
        updatedFilterDetail = {
          industries: industries,
          categories: categories,
          attributes: [attributes[0]],
          min: min ? min : "",
          max: max ? max : "",
          operator: data["value"],
        };
      } else {
        if (data["value"] === "EQ" || data["value"] === "NOT_EQ") {
          updatedFilterDetail = {
            industries: industries,
            categories: categories,
            attributes: attributes,
            values: values ? values : [],
            operator: data["value"],
          };
        } else {
          updatedFilterDetail = {
            industries: industries,
            categories: categories,
            attributes: attributes,
            values: values && values.length > 0 ? [values[0]] : [],
            operator: data["value"],
          };
        }
      }
      setfilterDetailData(updatedFilterDetail);
      setUpdatedFilterDetailFunction(updatedFilterDetail);
    }
  };

  const replace_condition_with_filter = () => {
    if (!insideCondition) {
      setfilterToCondition({
        function: "AND",
        conditions: [
          {
            function: "FILTER",
            filter: filterDetailData,
          },
          filter_template,
        ],
      });
    } else {
      updateConditionfunction(
        {
          function: "AND",
          conditions: [
            {
              function: "FILTER",
              filter: filterDetailData,
            },
            filter_template,
          ],
        },
        position
      );
    }
  };

  useEffect(() => {
    setSelectedAttr(selectedAttributes);
  }, [selectedAttributes, setSelectedAttr]);

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      fontSize: ".8rem",
      color: "black",
      fontWeight: "500",
      fontFamily: "Noto Sans",
      border: `1px solid ${showError1 || showError2 ? "#c13e25" : "#ced4da"}`,
      borderRadius: "4px",
    }),
  };

  return (
    <React.Fragment>
      {filterDetailData && (
        <div>
          <div className="d-flex">
            <div className="col-md-6 d-flex">
              <div className="col-md-6 form-group pe-4">
                <label
                  className="pb-1"
                  style={{
                    fontWeight: "400",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Categories
                </label>
                <Select
                  className="shadow-none  "
                  options={dropDownSelectedCategories}
                  isMulti
                  isDisabled={!toUpdate}
                  isSearchable
                  id="categories"
                  aria-label="Category"
                  value={selectedCategories}
                  onChange={(e) => {
                    updateCategorySelected(e);
                  }}
                  placeholder={toUpdate ? "Select Categories" : ""}
                  styles={customStyles}
                  maxMenuHeight={220}
                  menuPlacement="auto"
                  
                  isClearable={false}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
              <div className="col-md-6 form-group pe-4">
                <label
                  className="pb-1"
                  style={{
                    fontWeight: "400",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Attributes
                </label>
                <Select
                  className="shadow-none border-1 "
                  //isDisabled={!toUpdate}
                  isDisabled={true}
                  options={dropDownSelectedAttributes}
                  isMulti={filterDetailData.operator === "RANGE" ? false : true}
                  isSearchable
                  id="attributes"
                  aria-label="Attributes"
                  value={selectedAttributes}
                  onChange={(e) => {
                    updateAttributeSelected(e);
                  }}
                  placeholder={toUpdate ? "Select Attributes" : ""}
                  styles={customStyles}
                  maxMenuHeight={220}
                  menuPlacement="auto"
                  
                  isClearable={false}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
            </div>
            <div className="col-md-6 d-flex ">
              <div className="col-md-3  align-self-center pt-5  pe-4 ">
                <Select
                  className="shadow-none border-1 "
                  options={[
                    { value: "EQ", label: "==" },
                    { value: "GT", label: ">" },
                    { value: "LT", label: "<" },
                    { value: "GTE", label: ">=" },
                    { value: "LTE", label: "<=" },
                    { value: "NOT_EQ", label: "!=" },
                    { value: "RANGE", label: "RANGE" },
                  ]}
                  isSearchable
                  //isDisabled={selectedAttributes.length === 0 || !toUpdate}
                  isDisabled={true}
                  id="operator"
                  aria-label="Operator"
                  value={selectedOperator}
                  onChange={(e) => {
                    updatedOperatorSelected(e);
                  }}
                  placeholder={toUpdate ? "Operator" : ""}
                  styles={customStyles}
                  maxMenuHeight={220}
                  menuPlacement="auto"
                  
                  isClearable={false}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
              {filterDetailData.operator !== "RANGE" ? (
                <div className="col-md-6 form-group pe-4">
                  <label
                    className="pb-1"
                    style={{
                      fontWeight: "400",
                      fontFamily: "Noto Sans",
                    }}
                  >
                    Attribute Values
                  </label>
                  <Select
                    className="shadow-none border-1 "
                    options={dropDownSelectedValues}
                    isMulti={
                      filterDetailData.operator === "EQ" ||
                      filterDetailData.operator === "NOT_EQ"
                        ? true
                        : false
                    }
                    isSearchable
                    // isDisabled={selectedAttributes.length === 0 || !toUpdate}
                    isDisabled={true}
                    id="values"
                    aria-label="Values"
                    value={selectedValues}
                    onChange={(e) => {
                      updatedValueSelected(e);
                    }}
                    placeholder={toUpdate ? "Select Attribute Values" : ""}
                    styles={customStyles}
                    maxMenuHeight={220}
                    menuPlacement="auto"
                    
                    isClearable={false}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
              ) : (
                <div className="d-flex col-md-6">
                  <div className="form-group col pe-4">
                    <label
                      className="pb-1"
                      style={{
                        fontWeight: "400",
                        fontFamily: "Noto Sans",
                      }}
                    >
                      Min value
                    </label>
                    <Select
                      className="shadow-none border-1 "
                      options={dropDownSelectedValues}
                      isSearchable
                      isDisabled={selectedAttributes.length === 0 || !toUpdate}
                      id="min"
                      aria-label="Min"
                      value={selectedMinValues}
                      onChange={(e) => {
                        updatedMinValueSelected(e);
                      }}
                      placeholder="Min value"
                      styles={customStyles}
                      maxMenuHeight={220}
                      menuPlacement="auto"
                      
                      isClearable={false}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </div>
                  <div className="form-group col pe-4">
                    <label
                      className="pb-1"
                      style={{
                        fontWeight: "400",
                        fontFamily: "Noto Sans",
                      }}
                    >
                      Max value
                    </label>
                    <Select
                      className="shadow-none border-1 "
                      options={dropDownSelectedValues}
                      isSearchable
                      isDisabled={selectedAttributes.length === 0 || !toUpdate}
                      id="max"
                      aria-label="Max"
                      value={selectedMaxValues}
                      onChange={(e) => {
                        updatedMaxValueSelected(e);
                      }}
                      placeholder="Max Value"
                      styles={customStyles}
                      maxMenuHeight={220}
                      menuPlacement="auto"
                      
                      isClearable={false}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </div>
                </div>
              )}
              {toUpdate && (
                <div className="col-md-1 pt-4">
                  <button
                    className="btn-sm"
                    style={{
                      color: "rgb(9, 28, 170)",
                      paddingTop: "0px",
                      marginTop: "32px",
                      paddingBottom: "0px",
                      border: "solid 1px #c9cccf",
                      backgroundColor: "white",
                      padding: "0px 6px 0px 6px",
                    }}
                    onClick={replace_condition_with_filter}
                  >
                    +
                  </button>
                </div>
              )}
              {insideCondition && toUpdate && (
                <div className="col-md-1 pt-4">
                  <button
                    className="btn-sm"
                    style={{
                      color: "rgb(9, 28, 170)",
                      paddingTop: "0px",
                      marginTop: "32px",
                      paddingBottom: "0px",
                      border: "solid 1px #c9cccf",
                      backgroundColor: "white",
                      padding: "0px 6px 0px 6px",
                    }}
                    onClick={() => {
                      if (insideCondition) {
                        remove_filter_inside_condition(position);
                      }
                    }}
                  >
                    -
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="d-flex">
            <div
              id="nameHelp"
              className="form-text pe-2"
              style={{
                fontFamily: "Noto Sans",
                fontWeight: "500",
                fontSize: "0.75rem",
                display: `${!showError1 ? "none" : "block"}`,
                color: "#c13e25",
              }}
            >
              Enter either Category or (Attribute and value) or both
            </div>
            <div
              id="nameHelp2"
              className="form-text"
              style={{
                fontFamily: "Noto Sans",
                fontWeight: "500",
                fontSize: "0.75rem",
                display: `${!showError2 ? "none" : "block"}`,
                color: "#c13e25",
              }}
            >
              Enter Attribute, min value and max value
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default BuilderFilter;
